module.exports = __webpack_public_path__ + "static/img/banner-sept-10.11b7bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-sept-10.png
// module id = p8t+
// module chunks = 1